import React, { useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ReplayLoader } from './ReplayLoader';
import { ReplayRoom } from './ReplayRoom';
import { ReplayEngine } from '../../services/replay/ReplayEngine';
import { ReplayFile } from '../../services/replay/types';

export const ReplayPage: React.FC = () => {
  const { gameId } = useParams<{ gameId: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const [engine, setEngine] = useState<ReplayEngine | null>(null);
  const [file, setFile] = useState<ReplayFile | null>(null);

  function handleReady(eng: ReplayEngine, f: ReplayFile) {
    setEngine(eng);
    setFile(f);
  }

  const handleClose = () =>
    location.key !== 'default' ? navigate(-1) : navigate('/');

  if (!gameId) return null;

  return (
    <Dialog fullScreen open onClose={handleClose}>
      <DialogTitle sx={{ p: 1 }}>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 0 }}>
        {!engine || !file ? (
          <ReplayLoader gameId={gameId} onReady={handleReady} />
        ) : (
          <ReplayRoom
            engine={engine}
            file={file}
            profileId={file.header.players[0]?.profileId ?? 'viewer'}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};
